var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.series[0].data.length)?_c('dashboard-chart',{attrs:{"title":"Top RPM par site","type":"bar","loading":_vm.loading,"colors":_vm.colors,"series":_vm.series,"categories":_vm.categories,"chartOptions":_vm.dashboardMainChartOptions,"dags":[
      'ga_get_and_store_site_daily_dag',
      'partner_get_and_store_daily_dag',
      'partner_get_and_store_daily_ifempty_dag' ]}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }